import getCompanyInitials from 'utils/getCompanyInitials/getCompanyInitials';

const ORDER_NUMBER_PREFIX = 'ORD';

/**
 * @description Gets the order number, the same way the API does: the first ten
 * characters of the order id, behind "ORD" and the company initials when known.
 * "Acme Events Ltd" gives "ORD-AEL-3F9A1C27B4".
 * @param {{
 * id : string
 * prefix : string
 * companyName : string
 * }}
 */
function getOrderNumber({ id, prefix = '', companyName = '' }) {
  if (!id) {
    return '';
  }
  const idPart = id.replace(/-/g, '').substring(0, 10).toUpperCase();
  const initials = getCompanyInitials(companyName);
  const numberParts = initials
    ? [ORDER_NUMBER_PREFIX, initials, idPart]
    : [ORDER_NUMBER_PREFIX, idPart];
  return `${prefix}${numberParts.join('-')}`;
}

export default getOrderNumber;
